export default __webpack_public_path__ + "static/media/ascension.ad412e77.jpg";